(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-lashes-video"] && !Shopify.designMode) return;
  try {
    
        const play = document.querySelector('.play-video');
        const poster = document.querySelector('.video-poster');
        const vid = document.getElementById("myVideo");
        function playVid() {
          vid.play();
        }
         play.addEventListener('click',function(){
          playVid();
          this.classList.add('hide');
          poster.classList.add('hide');
        })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-review-section"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', () => {
   // Change option selected
  const label = document.querySelector('.dropdown__filter-selected')
  const options = Array.from(document.querySelectorAll('.dropdown__select-option'))

  options.forEach((option) => {
  	option.addEventListener('click', () => {     
  		label.textContent = option.textContent;
    	const toggle = document.querySelector('.dropdown__switch');
        toggle.checked = false;      
  	})
  })

  // Close dropdown onclick outside
  document.addEventListener('click', (e) => {
  	const toggle = document.querySelector('.dropdown__switch')
  	const element = e.target    
  	if (element == toggle) return;
  	const isDropdownChild = element.closest('.dropdown__filter')
  	if (!isDropdownChild) {     
  		toggle.checked = false
  	}
  })
    }); // end DOMContentLoaded

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
let tab = function () {
    let tabNav = document.querySelectorAll('.tabs-nav__item'),
        tabContent = document.querySelectorAll('.tab'),
        tabName;

    tabNav.forEach(item => {
        item.addEventListener('click', selectTabNav)
    });


    function selectTabNav() {
        tabNav.forEach(item => {
            item.classList.remove('is-active');
        });
        this.classList.add('is-active');
        tabName = this.getAttribute('data-tab-name');
        selectTabContent(tabName);
    }

    function selectTabContent(tabName) {
        tabContent.forEach(item => {
            item.classList.contains(tabName) ? item.classList.add('is-active') : item.classList.remove('is-active');
        })
    }

};

tab();

}); // end DOMContentLoaded

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            //Preview product card slider -- global js
            previewCardSlider() 
            // chnage image card when hover color swatcher -- global.js
            chnageImageCardProdactPreview()
          }) 
          .catch(e => {
            console.error(e);
          });
      } 

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-alsolike"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

	var swiper = new Swiper(".collectin-products", {
		slidesPerView: 6,
		spaceBetween: 30,
		freeMode: true,
		loop: true,
		breakpoints: {
			1400: {
				slidesPerView: 6
			},
			1024: {
				slidesPerView: 4
			},
			991: {
				slidesPerView: 4
			},
			768: {
				slidesPerView: 3
			},
			320: {
				slidesPerView: 2
			}
		}
	});

}); // end DOMContentLoaded


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-video-review"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
let tab = function () {
    let tabNav = document.querySelectorAll('.tabs-nav__item'),
        tabContent = document.querySelectorAll('.tab'),
        tabName;

    tabNav.forEach(item => {
        item.addEventListener('click', selectTabNav)
    });


    function selectTabNav() {
        tabNav.forEach(item => {
            item.classList.remove('is-active');
        });
        this.classList.add('is-active');
        tabName = this.getAttribute('data-tab-name');
        selectTabContent(tabName);
    }

    function selectTabContent(tabName) {
        tabContent.forEach(item => {
            item.classList.contains(tabName) ? item.classList.add('is-active') : item.classList.remove('is-active');
        })
    }

};

tab();

}); // end DOMContentLoaded

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tab-video"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
let tab = function () {
    let tabNav = document.querySelectorAll('.tabs-nav__item'),
        tabContent = document.querySelectorAll('.tab'),
        tabName;

    tabNav.forEach(item => {
        item.addEventListener('click', selectTabNav)
    });


    function selectTabNav() {
        tabNav.forEach(item => {
            item.classList.remove('is-active');
        });
        this.classList.add('is-active');
        tabName = this.getAttribute('data-tab-name');
        selectTabContent(tabName);
    }

    function selectTabContent(tabName) {
        tabContent.forEach(item => {
            item.classList.contains(tabName) ? item.classList.add('is-active') : item.classList.remove('is-active');
        })
    }

};

tab();

    $('.playbtn').on('click', function(){
        $(this).parent().addClass('active');
        const playVideo = $(this).parent().next('.videobox');
        playVideo.trigger('play');
    });
}); // end DOMContentLoaded

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tik-tok-step-section"] && !Shopify.designMode) return;
  try {
    

$( document ).ready(function() {
    console.log( "ready!" );
  $( ".step-popup-btn" ).click(function() {
     $( ".step-section__video" ).css('display', 'flex')
  });
$( ".step-section__video" ).click(function() {
     $('#video-step').trigger('pause')
     $( ".step-section__video" ).css('display', 'none')
     
  });
  
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-text"] && !Shopify.designMode) return;
  try {
    
        const play = document.querySelector('.play-video');
        const poster = document.querySelector('.video-poster');
        const vid = document.getElementById("myVideo");
        function playVid() {
          vid.play();
        }
         play.addEventListener('click',function(){
          playVid();
          this.classList.add('hide');
          poster.classList.add('hide');
        })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-text2"] && !Shopify.designMode) return;
  try {
    
        const play = document.querySelector('.play-video');
        const poster = document.querySelector('.video-poster');
        const vid = document.getElementById("myVideo");
        function playVid() {
          vid.play();
        }
         play.addEventListener('click',function(){
          playVid();
          this.classList.add('hide');
          poster.classList.add('hide');
        })

  } catch(e) { console.error(e); }
})();
})();
